import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';
import { BILLING_SUBSCRIPTION_STATUS, BillingSubscriptionStatusType } from '@/const/shared';

const SUBSCRIPTION_STATUS_MAP: StatusType = {
  [BILLING_SUBSCRIPTION_STATUS.ACTIVE]: { title: 'Active', variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [BILLING_SUBSCRIPTION_STATUS.GRACE]: { title: 'Grace Period', variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
  [BILLING_SUBSCRIPTION_STATUS.SUSPENDED]: { title: 'Suspended', variant: STATUS_VARIANT_HIGHLIGHT.RED },
  [BILLING_SUBSCRIPTION_STATUS.CANCELLED]: { title: 'Cancelled', variant: STATUS_VARIANT_HIGHLIGHT.RED },
};

type SubscriptionStatusType = {
  status: BillingSubscriptionStatusType;
};

export const SubscriptionStatus = ({ status }: SubscriptionStatusType) => {
  const statusMap = SUBSCRIPTION_STATUS_MAP[status];

  return <StatusWrapper variant={statusMap?.variant}>{statusMap?.title}</StatusWrapper>;
};
